import { useTranslation } from "react-i18next";
import { Markup } from 'interweave';

export default function Hero(props){
    const { t } = useTranslation();

    const heroTitle = `<span class="heading-hero">${t('home.hero.influencing')}</span><span class="heading-hero white">${t('home.hero.futureof')}</span><span class="heading-hero red"><span class="typed-text"></span><span class="cursor">&nbsp;</span></span>`;

    return(
        <article>
            <section class="hero" id="hero">
                <div class="container hero-section">
                    <div class="row">
                        <div class="col left-hero-section">
                            <Markup content={heroTitle}></Markup>
                        </div>
                    </div>
                </div>
            </section>
        </article>
    )
}